import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-core',
  templateUrl: './core.component.html',
  styleUrls: ['./core.component.scss']
})
export class CoreComponent implements OnInit {

  userLoggedIn: Object;
  constructor(public router: Router) {
    //this.userLoggedIn = JSON.parse(localStorage.getItem('user'));
    this.userLoggedIn = JSON.parse(localStorage.getItem('credentials'));
    if (!this.userLoggedIn) {
      this.router.navigate(['/login']);
    }
  }

  ngOnInit() { }
}
